import styled from 'styled-components'

export const IconeAvatar = styled.img`
  max-width: 100%;
  border-radius: 50%;
  margin-bottom: 24px;
`
